import { Component, OnInit } from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { ManualModel, Manual} from './../../models/manuals.model';

@Component({
  selector: 'app-modal-manual',
  templateUrl: './modal-manual.component.html',
  styles: []
})
export class ModalManualComponent implements OnInit {
  manual : Manual;

  formControl = new FormControl('');
  modalForm : FormGroup;

  //Manipulamos la clase modal
  private _manualModel = new ManualModel;

  constructor(public activeModal: NgbActiveModal, private fb: FormBuilder) { }

  ngOnInit() {
    this.modalForm = this.fb.group({
      clave: [this.manual ? this.manual.clave : null],
      nombre: [this.manual ? this.manual.nombre : null],
      url: [this.manual ? this.manual.url : null],
      tipo: [this.manual ? this.manual.tipo : null],
      user: [this.manual ? this.manual.usuario : null],
      descripcion: [this.manual ? this.manual.descripcion : null],
    });
  }

  //Agregar dominio
  adminManual(){
    this.activeModal.close('Guardado datos');
    this._manualModel.createManual(this.modalForm.value);
  }

}
